import MySurveysTable, { ThElementsType } from "components/MySurveys/MySurveysTable";
import React, { useEffect, useState } from "react";
import { approvedDataHandler } from "./dataHandler";
import { usePanelistCompleteStatusData } from "hooks/usePanelistCompleteStatusData-hook";
import Pagination from "../../components/Pagination/Pagination";
import { useTranslation } from "react-i18next";
import { Badge, Card } from "components/ui";
interface ICheckBoxDataType {
  id: number | string;
  points: number;
  studyName: string;
}

const ThColumns: ThElementsType = {
  scope: "col",
  classes: "",
  dataKeys: [
    { id: 2, column: "Points", label: "points" },
    { id: 3, column: "Survey Name", label: "studyName" },
    { id: 4, column: "Date", label: "createdAt" },
    { id: 5, column: "Status", label: "status" },
  ],
};

export const ClaimedStudiesApproved = ({ setLoading }: any) => {
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [recordsPerPage] = useState(10);
  const { t } = useTranslation();
  // eslint-disable-next-line
  const [approvedStudy, setApprovedStudy] = useState(false);
  const [checkedData, setCheckedData] = useState<[] | ICheckBoxDataType[]>([]);
  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;

  const data = usePanelistCompleteStatusData({
    page: currentPage,
    fromDate: "2023-12-01+14:58:53",
    type: "approved",
  });

  useEffect(() => {
    if (data?.isLoading || data?.isFetching) {
      setLoading(true);
    } else {
      setLoading(false);
    }
  }, [data?.isLoading, data?.isFetching, data?.data]);

  const handleCheckBox = (item, checkedData: [] | ICheckBoxDataType[]) => {
    if (checkedData?.some((checkedElement: ICheckBoxDataType) => checkedElement.id === item.id)) {
      setCheckedData(checkedData.filter((checkedElement: ICheckBoxDataType) => checkedElement.id !== item.id));
    } else {
      setCheckedData([...checkedData, { id: item.id, points: item.points, studyName: item.sid }]);
    }
  };

  const statusDisplay = () => {
    return (
      <Badge tone="success" dot>
        {t("page.referral.Approved")}
      </Badge>
    );
  };

  const checkBoxes = (item, checkedData: [] | ICheckBoxDataType[]) => {
    return (
      <input
        className="w-4 h-4 rounded cursor-pointer accent-primary"
        type="checkBox"
        key={item.id}
        checked={checkedData?.some((checkedElement: ICheckBoxDataType) => checkedElement.id === item.id)}
        onClick={() => handleCheckBox(item, checkedData)}
      />
    );
  };

  const dataSet = approvedDataHandler({
    data,
    indexOfFirstRecord,
    indexOfLastRecord,
    status: statusDisplay(),
    checkBoxAction: checkBoxes,
    checkedData,
  });

  return (
    <Card title="Approved studies" subtitle="Study claims that passed review." flush>
      <MySurveysTable
        thElements={ThColumns}
        tdElements={dataSet}
        searchQuery="searchQuery"
        tdDataStyle=""
        tdRowStyle=""
        tableStyle=""
        startIndex={(currentPage - 1) * 10}
      />
      <div className="zs-table-footer justify-center sm:justify-end">
        <Pagination totalPages={data?.data?.totalPages} setCurrentPage={setCurrentPage} currentPage={currentPage} />
      </div>
    </Card>
  );
};
